import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

const sizes = {
  sm: 'w-8 h-8 border-2',
  md: 'w-12 h-12 border-4',
  lg: 'w-16 h-16 border-4'
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  color = 'gold',
  className = ''
}) => {
  const sizeClasses = sizes[size];
  const borderColorClass = `border-${color}/20 border-t-${color}`;

  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <motion.div
        className={`${sizeClasses} ${borderColorClass} rounded-full`}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
        role="progressbar"
        aria-label="Loading"
      />
    </div>
  );
};

export const LoadingOverlay: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 shadow-xl">
        <LoadingSpinner size="lg" />
        {message && (
          <p className="text-center text-gold-dark mt-4 font-medium">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};